import React from 'react';
import { Form } from 'react-bootstrap';
import ProcessBooleanField from './ProcessBooleanField';
import Attention from '../ReusableComponents/Attention';
import FormFieldHelp from '../ReusableComponents/FormFieldHelp';

export default function FaceValidationReleaseSettings({ allowContinue, onAllowContinue, minutes, onMinutesChange, chatType }) {
    const label = allowContinue
        ? 'Tempo em minutos antes da avaliação para exibir o botão "Continuar sem concluir a validação facial"'
        : 'Tempo em minutos antes da avaliação para exibir o botão de pedir liberação ao fiscal';
    return <div className="process-release-settings">
        <ProcessBooleanField id="allow-face-validation-skip" value={allowContinue} onChange={onAllowContinue}
            label="Permitir que o candidato continue sem concluir a validação facial"
            help="Permite continuar com a câmera compartilhada após o prazo de liberação. O candidato confirma um aviso, e a ação é registrada nos logs. O pedido de liberação ao fiscal fica oculto. A exibição do chat é configurada separadamente." />
        <div className="process-release-time">
            <Form.Label htmlFor="face-validation-release-time">{label} <Attention /> <FormFieldHelp>
                {allowContinue
                    ? 'Define a antecedência para disponibilizar o botão Continuar sem concluir a validação facial. Exemplo: 60 minutos permite exibi-lo uma hora antes do início, após 25 segundos de espera na validação.'
                    : 'Define a antecedência para disponibilizar o pedido de liberação ao fiscal. Exemplo: 60 minutos permite exibi-lo uma hora antes do início, após 25 segundos de espera na validação.'}
                {chatType === 'none' && !allowContinue && ' Para permitir que o candidato continue sem a liberação do fiscal, habilite a opção acima.'}
            </FormFieldHelp></Form.Label>
            <Form.Control id="face-validation-release-time" type="number" min={1} required placeholder="Tempo em minutos"
                value={minutes} onChange={event => onMinutesChange(event.target.value)} />
        </div>
    </div>;
}
